// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1a8j8","description":"MealItem_description__3nE3A","price":"MealItem_price__CiI5d"};